import { render, staticRenderFns } from "./Compact.vue?vue&type=template&id=02890b5b&scoped=true&lang=pug&"
import script from "./Compact.vue?vue&type=script&lang=js&"
export * from "./Compact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02890b5b",
  null
  
)

export default component.exports